module.exports = __webpack_public_path__ + "img/Maleficae_Megnyito_W02.a7ab1edc.jpg";